// blockscripts.js
// 🧠 User intent triggers
/* const userIntentEvents = [
  "mousemove",
  "mousedown",
  "scroll",
  "keydown",
  "touchstart"
];

function unblockAllScripts() {
  if (window.unblockedScripts?.unblocked) return;

  window.unblockedScripts = { unblocked: true };

  if (window.yett && typeof window.yett.unblock === 'function') {
    console.log("▶️ Unblocking scripts");
    window.yett.unblock();
    window.yettLoaded = true;
  } else {
    console.warn("⚠️ Yett not available at unblock time");
  }

  // Save state for this session
  try {
    sessionStorage.setItem("scripts-unblocked", JSON.stringify({ unblocked: true }));
  } catch (e) {
    console.warn("SessionStorage not available", e);
  }

  // Remove listeners to avoid memory leaks
  userIntentEvents.forEach(event =>
    window.removeEventListener(event, unblockAllScripts, true)
  );
}

// Check if previously unblocked
try {
  const previouslyUnblocked = JSON.parse(
    sessionStorage.getItem("scripts-unblocked") || "{}"
  );
  
  if (previouslyUnblocked.unblocked) {
    console.log("✅ Scripts already unblocked this session");
    window.unblockedScripts = { unblocked: true };
    window.yett.unblock();
    window.yettLoaded = true;
  } else {
    userIntentEvents.forEach(event =>
      window.addEventListener(event, unblockAllScripts, {
        once: true,
        passive: true,
        capture: true
      })
    );

    setTimeout(() => {
      if (!window.unblockedScripts?.unblocked) {
        console.log("⏰ Unblocking scripts via timeout fallback");
        unblockAllScripts();
        window.yettLoaded = true;
      }
    }, 300);
  }
} catch (e) {
  console.error("Error during script unblocking logic", e);
} */

/* console.log("🔥 blockscripts.js loaded");

// Espera a que Yett esté disponible antes de seguir
function whenYettReady(cb, attempts = 0) {
  if (window.yett && typeof window.yett.unblock === "function") {
    console.log("✅ Yett detected, initializing delayed logic...");
    cb();
  } else if (attempts < 50) {
    setTimeout(() => whenYettReady(cb, attempts + 1), 100);
  } else {
    console.warn("⚠️ Yett not found after waiting.");
  }
}

whenYettReady(() => {
  console.log("🧩 Setting up delayed releases...");
  setTimeout(() => {
    console.log("🕓 Releasing All scripts...");
    window.yett.unblock();
    window.yettLoaded = true;
  }, 2000);

  // --- Delayed releases ---
   setTimeout(() => {
    console.log("🕓 Releasing non-critical scripts (global delay)");
    window.yett.unblock(/upsell|vwo|posthog|searchanise|optmstr|visualwebsiteoptimizer/);
    window.yett.unblock();
  }, 3000);
}); */
/* (function () {
  // Bandera GLOBAL (sobrevive si el archivo se ejecuta 2+ veces)
  if (window.__SCRIPTS_UNBLOCKED__) {
    console.log('✅ Scripts already unblocked (global flag)');
    return;
  }

  // Eventos de intención (defínelos una sola vez en este scope)
  var userIntentEvents = ['mousemove', 'mousedown', 'scroll', 'keydown', 'touchstart'];

  function release() {
    // Idempotencia: si ya liberaste, sal
    if (window.__SCRIPTS_UNBLOCKED__) return;

    window.__SCRIPTS_UNBLOCKED__ = true; // <-- bandera global
    try { sessionStorage.setItem('scripts-unblocked', '1'); } catch (e) { }

    if (window.yett && typeof window.yett.unblock === 'function') {
      console.log('▶️ Unblocking all via Yett (except Searchanise)');
      try {
        // Unblock everything EXCEPT searchanise
        window.yett.unblock(new RegExp('^(?!.*searchanise).*$'));
      } catch (e) { console.warn('Yett unblock failed', e); }
    }

    // Limpia listeners (por si esta instancia los registró)
    userIntentEvents.forEach(function (evt) {
      window.removeEventListener(evt, onIntent, true);
    });
  }

  function onIntent() { release(); }

  // Si ya liberaste en esta sesión, libéralo inmediato y sal
  try {
    if (sessionStorage.getItem('scripts-unblocked') === '1') {
      console.log('✅ Scripts already unblocked this session');
      return release();
    }
  } catch (e) { }

  // Registra triggers UNA vez por instancia (idempotente por la bandera global)
  userIntentEvents.forEach(function (evt) {
    window.addEventListener(evt, onIntent, { once: true, passive: true, capture: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(release, { timeout: 800 });
  }
  setTimeout(release, 800);
})(); */
(function () {
  if (window.__SCRIPTS_UNBLOCKED__) return;

  var userIntentEvents = ['mousemove', 'mousedown', 'scroll', 'keydown', 'touchstart'];
  
  // Detect mobile once
  //var isMobileBlock = window.matchMedia('(max-width: 749px)').matches;
  var isMobileBlock = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  //console.log('is mobile?', isMobileBlock);
  // Different fallback timeouts by device
  var fallbackDelay = isMobileBlock ? 2000 : 800;
  if (
    location.pathname === "/pages/search-results-page" ||
    location.pathname === "/search" 
  ) {
    if(isMobileBlock) {
      fallbackDelay = 0;
    } else {
      fallbackDelay = 0;
    }
  }
  //console.log("see fallback", fallbackDelay);

  // ---------------------------------------------------------------------------
  // Gorgias chat — collection pages only.
  // Gorgias runs ~1.2s of JS on collection pages, so there it is excluded from the
  // global release below and loaded on scroll, click, or after 5s instead.
  // All other page types keep the existing release behaviour untouched.
  // Matches /collections/<handle> and /collections/<handle>/<tag>, with an optional
  // locale prefix. Does NOT match /collections/<handle>/products/<product> (product page).
  // ---------------------------------------------------------------------------
  var isCollectionPage = /^(\/[a-z]{2}(-[a-z0-9]+)?)?\/collections\/[^\/]+(\/(?!products(\/|$))[^\/]+)?\/?$/i.test(location.pathname);
  var GORGIAS_FALLBACK_DELAY = 5000;
  var gorgiasReleased = false;
  var gorgiasWatchStarted = false;

  // Fires `gorgias:loaded` on document once window.GorgiasChat exists, so callers
  // (e.g. the footer "Chat with us" link) can wait for the widget. Gorgias has no
  // equivalent event we can rely on, so we poll (200ms, up to 30s).
  function watchGorgiasLoaded() {
    if (gorgiasWatchStarted) return;
    gorgiasWatchStarted = true;
    var tries = 0;
    (function check() {
      if (typeof window.GorgiasChat !== 'undefined') {
        document.dispatchEvent(new Event('gorgias:loaded'));
        return;
      }
      if (++tries < 150) setTimeout(check, 200);
    })();
  }

  function releaseGorgias() {
    if (gorgiasReleased) return;
    gorgiasReleased = true;
    window.removeEventListener('scroll', releaseGorgias, true);
    window.removeEventListener('click', releaseGorgias, true);

    if (window.yett && typeof window.yett.unblock === 'function') {
      try {
        window.yett.unblock(/gorgias/);
      } catch (e) { console.warn('Yett unblock (gorgias) failed', e); }
    }
    watchGorgiasLoaded();
  }

  function holdGorgiasUntilInteraction() {
    window.addEventListener('scroll', releaseGorgias, { once: true, passive: true, capture: true });
    window.addEventListener('click', releaseGorgias, { once: true, passive: true, capture: true });
    setTimeout(releaseGorgias, GORGIAS_FALLBACK_DELAY);
  }

  // Global release regex: everything except Searchanise (unchanged), and on
  // collection pages also except Gorgias (released separately above).
  var releaseRegex = isCollectionPage
    ? new RegExp('^(?!.*(searchanise|gorgias)).*$')
    : new RegExp('^(?!.*searchanise).*$');

  function release() {
    if (window.__SCRIPTS_UNBLOCKED__) return;
    window.__SCRIPTS_UNBLOCKED__ = true;
    try { sessionStorage.setItem('scripts-unblocked', '1'); } catch (e) {}

    if (window.yett && typeof window.yett.unblock === 'function') {
      try {
        window.yett.unblock(releaseRegex);
      } catch (e) { console.warn('Yett unblock failed', e); }
    }

    userIntentEvents.forEach(function (evt) {
      window.removeEventListener(evt, onIntent, true);
    });

    // Lets the footer chat link wait for Gorgias (see sections/footer.liquid).
    watchGorgiasLoaded();
  }

  function onIntent() { release(); }

  // Must be set up before the return-visit branch below, which returns early.
  if (isCollectionPage) holdGorgiasUntilInteraction();

  // Return visit — delay proportionally by device
  try {
    if (sessionStorage.getItem('scripts-unblocked') === '1') {
      var returnDelay = isMobileBlock ? 4000 : 2000;
      if (
        location.pathname === "/pages/search-results-page" ||
        location.pathname === "/search" 
      ) {
        if(isMobileBlock) {
          returnDelay = 0;
        } else {
          returnDelay = 0;
        }
      }
      //console.log("see returnDelay", returnDelay);
      return setTimeout(release, returnDelay);
    }
  } catch (e) {}

  // First visit — intent triggers immediately, timeout as fallback
  userIntentEvents.forEach(function (evt) {
    window.addEventListener(evt, onIntent, { once: true, passive: true, capture: true });
  });

  // Fallback only — intent events will fire first on real mobile users
  if ('requestIdleCallback' in window) {
    requestIdleCallback(release, { timeout: fallbackDelay });
  } else {
    setTimeout(release, fallbackDelay);
  }
})();